import { useState } from 'react'
import UserApplication from './UserContext'
import {apiurl} from '../../../path'

const UserStateApplication = (props) => {

  
    let token = localStorage.getItem('Usertoken')
    let AuctionToken=localStorage.getItem('AuctionToken')
    const [Data, SetData] = useState()
    const [paymentdata, setpaymentdata] = useState()
    const [Notice, SetNotification] = useState({
        notice:"",
        color:""
    })
    const [AuctionData,SetAuctionData]=useState([])

    const userdata = async (type) => {
        try {
            let data = await fetch(apiurl+'/BidderRegister', {
            method: "post",
            headers: { "Content-Type": "application/json", AuthToken: token },
            body: JSON.stringify({type:type}),
        });
        data = await data.json();
        return data
        } catch (error) {
            console.error('Error in userdata:', error);
          }
       
    }

    const TenderRegisterHash=async(form)=>{
        try {
            let call = await fetch(apiurl+'/payment/TenderRegisterHash', {
            method: 'post', headers: { 'Content-Type': 'application/json','AuthToken':token }, body: JSON.stringify({...form})
        })
        call = await call.json()
        return call
        } catch (error) {
            console.error('Error in TenderRegisterHash:', error);
          }
    }

    const TenderPayment = async (form, secondform) => {
        try {
            const combinedForm = {
                ...form,
                ...secondform
            };
        
            let call = await fetch(apiurl + '/payment/TenderPayment', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'AuthToken': token
                },
                body: JSON.stringify(combinedForm)
            });
        
            call = await call.json();
            if(call===true){
                alert('Successfully Registered')
                
            }
            else{
                alert('failed Registeration due to already regestered')
                
            }
            return call;
        } catch (error) {
            console.error('Error in TenderPayment:', error);
          }
    };

    const GetPaymentHistory=async()=>{
        try {
            let response = await fetch(apiurl+'/GetPaymentHistory',{method:'post',headers:{'Content-Type':'application/json',AuthToken:token},body:JSON.stringify({})});
        response = await response.json(); 
        return response
        } catch (error) {
            console.error('Error in GetPaymentHistory:', error);
          }
    }

    const GetAuctionsList=async(type,searchPattern,Auction_ID,Auction_Name)=>{   
        try {
            let data=await fetch(apiurl+'/BidderRegister/Tenders',{method:"POST",
        headers:({'Content-Type': 'Application/json','AuthToken':token}),
        body:JSON.stringify({type:type,searchPattern:searchPattern,Auction_ID:Auction_ID,Auction_Name:Auction_Name})})
        data=await data.json()
        return data
        } catch (error) {
            console.error('Error in GetAuctionsList:', error);
          }
    }

    const CompanyForm=async(type,searchPattern)=>{
        try {
            let data=await fetch(apiurl+'/BidderRegister/CompanyForm',{method:"POST",
        headers:({'Content-Type': 'Application/json','AuthToken':token}),
        body:JSON.stringify({type:type,searchPattern:searchPattern})})
        data=await data.json()
        return data
        } catch (error) {
            console.error('Error in CompanyForm:', error);
          }
    }

    const DownloadReciept=async(Tender_ID,GST_No,PAN_No,status)=>{
        try {
            let data=await fetch(apiurl+'/GetAuctions/DownloadReciept',{method:"POST",
        headers:({'Content-Type': 'Application/json','AuthToken':token}),
        body:JSON.stringify({Tender_ID:Tender_ID,GST_No:GST_No,PAN_No:PAN_No,status:status})})
        data=await data.json()
        setpaymentdata(data[0])
        return data 
        } catch (error) {
            console.error('Error in DownloadReciept:', error);
          }
    }

    return (
        <UserApplication.Provider value={{Notice, SetNotification, DownloadReciept,TenderPayment,TenderRegisterHash,CompanyForm,GetAuctionsList,GetPaymentHistory,SetAuctionData, userdata,paymentdata, setpaymentdata}} >
            {props.children}
        </UserApplication.Provider>
    )
}
export default UserStateApplication